/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gift_RedeemedInputs */

const en_gift_redeemed = /** @type {(inputs: Gift_RedeemedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Redeemed`)
};

const es_gift_redeemed = /** @type {(inputs: Gift_RedeemedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Canjeado`)
};

const fr_gift_redeemed = /** @type {(inputs: Gift_RedeemedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Réclamé`)
};

const de_gift_redeemed = /** @type {(inputs: Gift_RedeemedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Eingelöst`)
};

const id_gift_redeemed = /** @type {(inputs: Gift_RedeemedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ditebus`)
};

/** @type {(inputs: Gift_RedeemedInputs) => LocalizedString} */
const ja_gift_redeemed = en_gift_redeemed;

/** @type {(inputs: Gift_RedeemedInputs) => LocalizedString} */
const zh_gift_redeemed = en_gift_redeemed;

/** @type {(inputs: Gift_RedeemedInputs) => LocalizedString} */
const ar_gift_redeemed = en_gift_redeemed;

/** @type {(inputs: Gift_RedeemedInputs) => LocalizedString} */
const it_gift_redeemed = en_gift_redeemed;

/** @type {(inputs: Gift_RedeemedInputs) => LocalizedString} */
const ru_gift_redeemed = en_gift_redeemed;

/** @type {(inputs: Gift_RedeemedInputs) => LocalizedString} */
const pt_gift_redeemed = en_gift_redeemed;

/** @type {(inputs: Gift_RedeemedInputs) => LocalizedString} */
const ko_gift_redeemed = en_gift_redeemed;

/**
* | output |
* | --- |
* | "Redeemed" |
*
* @param {Gift_RedeemedInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const gift_redeemed = /** @type {((inputs?: Gift_RedeemedInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gift_RedeemedInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gift_redeemed(inputs)
	if (locale === "es") return es_gift_redeemed(inputs)
	if (locale === "fr") return fr_gift_redeemed(inputs)
	if (locale === "de") return de_gift_redeemed(inputs)
	if (locale === "ja") return ja_gift_redeemed(inputs)
	if (locale === "zh") return zh_gift_redeemed(inputs)
	if (locale === "ar") return ar_gift_redeemed(inputs)
	if (locale === "id") return id_gift_redeemed(inputs)
	if (locale === "it") return it_gift_redeemed(inputs)
	if (locale === "ru") return ru_gift_redeemed(inputs)
	if (locale === "pt") return pt_gift_redeemed(inputs)
	return ko_gift_redeemed(inputs)
});